/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_ContinueInputs */



/**
* | output |
* | --- |
* | "To Practice" |
*
* @param {Onboarding_Pilot_Ready_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_continue = /** @type {((inputs?: Onboarding_Pilot_Ready_ContinueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_ContinueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Naar Oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vers S'entraîner")
	return /** @type {LocalizedString} */ ("To Practice")
});